/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterSortALowToHighIcon32Regular = forwardRef('UiFilterSortALowToHighIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5 6a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H5Z" }),
        React.createElement("path", { d: "M4 16a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M4 25a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z" })));
});
